import { TOUCH_TARGET_SIZE, belowSm } from './touchTarget';

// ----------------------------------------------------------------------

export default function IconButton(theme) {
  return {
    MuiIconButton: {
      styleOverrides: {
        root: belowSm(theme, {
          // O Autocomplete posiciona os indicadores com `top` calculado para 28 px e reserva só
          // esse espaço no padding do input: com 44 px o ícone desalinha e cobre o texto. As setas
          // do calendário moram num cabeçalho de 30 px e invadiriam a linha dos dias. O
          // `:where` zera a especificidade da exclusão, para um `sx` responsivo da tela
          // (`minHeight: { xs: 40 }`) ainda vencer. Um `sx` sem breakpoint perde: o emotion o põe
          // na regra base, antes deste `@media`.
          '&:not(:where(.MuiAutocomplete-popupIndicator, .MuiAutocomplete-clearIndicator, .MuiPickersArrowSwitcher-button))':
            {
              minWidth: TOUCH_TARGET_SIZE,
              minHeight: TOUCH_TARGET_SIZE,
            },
        }),
      },
    },
  };
}
